import SpriteSymbol from "../../../node_modules/.pnpm/svg-baker-runtime@1.4.7/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/.pnpm/svg-sprite-loader@6.0.11/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-pass1",
  "use": "icon-pass1-usage",
  "viewBox": "0 0 17 16",
  "content": "<symbol viewBox=\"0 0 17 16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-pass1\">\n<path d=\"M7.38831 14.811C5.36531 12.305 2.98531 10.408 1.33331 9.81296L5.25331 7.46096L7.14331 11.136C7.14331 11.136 10.2233 3.67396 15.0883 1.18896C14.9833 2.96696 14.5003 4.50696 15.3333 6.40396C13.1983 6.88696 8.81631 12.214 7.38831 14.811Z\" fill=\"#34C73B\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol